import { memo } from 'react';

import Btn from './Btn';
import { ReactComponent as FullscreenIcon } from '../../../icons/fullscreen.svg';
import { ReactComponent as FullscreenExitIcon } from '../../../icons/fullscreen-exit.svg';

const Fullscreen= ({ isFullscreen, onToggle }) => (
  <Btn
    label={isFullscreen ? 'Fullscreen Off' : 'Fullscreen'}
    onClick={onToggle}
  >
    {!isFullscreen && <FullscreenIcon />}
    {isFullscreen && <FullscreenExitIcon />}
  </Btn>
);

export default memo(Fullscreen);
